import React from 'react'
import { Link } from 'react-router-dom'
import Avatar from '../Elements/Avatar'
import Thumbnail from '../Elements/Thumbnail'
import { ProfileThumbnailArea } from '../Profile/Profilebar'
import { postdata } from '../contents/postdata'
import { profdata } from '../contents/profdata'
import './Home.css'

function BannerRegist() {
  return (
    <div className="banner-register">
      <div className="banner-register-introduce">
        <h2>憧れのあの人のおすすめが全てここから</h2>
        <h3>2022年3月β版リリース予定！</h3>
      </div>
      <div className="banner-register-button-area">
        <h4>SelectBook</h4>
        <a
          className="banner-register-button"
          href="https://whatisselectbook.web.app/"
        >
          <p>事前登録をする</p>
        </a>
      </div>
    </div>
  )
}

function RecommenderArea(props: any) {
  const authorid: string = props.authorid
  return (
    <div>
      <div className="recommender-avatar">
        <Link to={'/' + authorid} className="recommender-avatar-image">
          <Avatar src={profdata[authorid]['avatarimage']} />
        </Link>
        <div className="recommender-avatar-right">
          <Link to={'/' + authorid} className="recommender-avatar-name">
            {profdata[authorid]['name']}
          </Link>
          <p className="recommender-avatar-profession">
            {profdata[authorid]['profession']}
          </p>
        </div>
      </div>
      <ProfileThumbnailArea profid={authorid} multiline={false} />
    </div>
  )
}

export default function Home() {
  let recommenderAreas: any[] = []
  Object.keys(postdata).forEach((key) => {
    recommenderAreas.push(<RecommenderArea key={key} authorid={key} />)
  })
  window.scrollTo(0, 0)
  return (
    <div>
      <BannerRegist />
      <h1 className="thumbnailarea-title">
        <span>あのYouTuberのイチオシアイテム</span>
      </h1>
      {recommenderAreas}
    </div>
  )
}
